import { PermissionsHelper } from "./Permission";

export function isCVSplitApplied() {
    const dateTs = getCvSplitAppliedDate();

    if(dateTs) {
        return Date.now() >= dateTs;
    }

    return false;
}

export function getCvSplitAppliedDate() {
    const permission = new PermissionsHelper();

    let value = permission.get('general_settings', 'use_new_document_generation', 'value');

    let time = 1748584843000; //By default May 30

    if(value && value !== '0') {
        try {
            const date = new Date(value * 1000);
            let isValidDate = !isNaN(date.getTime());
    
            if(isValidDate) {
                time = value * 1000;
            }
        } catch (e) {}
    }

    return time;
}